import {
  uploadFile,
  uploadFileMetaData,
  removeFile,
  downloadFile,
  editFile,
  bookmarkFiles,
  deleteFiles,
  setFiles,
  setScopedFiles,
  pinFile,
  uploadScopedFile,
  removeScopedFile,
  setFilesLength,
  uploadFileInProgress,
} from '../routines';

const initialState = {
  isSaving: false,
  isDownloading: false,
  isDeleting: false,
  isPinning: false,
  files: [],
  scopedFiles: {},
  downloadLink: '',
  isCleared: false,
  isUploadError: false,
  scopedFilesLength: {},
};

const fileUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case deleteFiles.TRIGGER: {
      return {
        ...state,
        isDeleting: true,
      };
    }
    case removeScopedFile.TRIGGER:
    case uploadScopedFile.TRIGGER:
    case removeFile.TRIGGER:
    case uploadFile.TRIGGER: {
      return {
        ...state,
        isUploadError: false,
        isSaving: true,
      };
    }
    case setFilesLength.TRIGGER: {
      const { scope, length } = action.payload;
      return {
        ...state,
        scopedFilesLength: {
          ...state.scopedFilesLength,
          [scope]: length,
        },
      };
    }
    case uploadFileMetaData.TRIGGER: {
      return {
        ...state,
        isSaving: true,
        isCleared: false,
      };
    }
    case downloadFile.TRIGGER: {
      return {
        ...state,
        isDownloading: true,
      };
    }
    case pinFile.TRIGGER: {
      return {
        ...state,
        isPinning: true,
      };
    }
    case uploadFileInProgress.TRIGGER: {
      return {
        ...state,
        isSaving: true,
      };
    }
    case uploadFile.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        files: [...state.files, data],
        isSaving: false,
        isUploadError: false,
      };
    }
    case uploadScopedFile.SUCCESS: {
      const { scope, data, additionalData } = action.payload;
      if (additionalData?.emailCount) {
        data.emailCount = additionalData?.emailCount;
      }
      const updatedFilesLength =
        state.scopedFilesLength[scope] === state.scopedFiles[scope].length
          ? null
          : state.scopedFilesLength[scope];
      return {
        ...state,
        scopedFiles: {
          ...state.scopedFiles,
          [scope]: [...(state.scopedFiles[scope] || []), data],
        },
        scopedFilesLength: {
          ...state.scopedFilesLength,
          [scope]: updatedFilesLength,
        },
        isSaving: false,
        isUploadError: false,
      };
    }
    case setFiles.TRIGGER: {
      return {
        ...state,
        files: [...action.payload],
      };
    }
    case setScopedFiles.TRIGGER: {
      const { files, scope } = action.payload;
      return {
        ...state,
        scopedFiles: { ...state.scopedFiles, [scope]: [...files] },
      };
    }
    case removeFile.SUCCESS: {
      const { fileMetaDataId, clearAll } = action.payload;
      const fileData = [...state.files];
      const index = fileData.findIndex((file) => file.uid === fileMetaDataId);
      fileData.splice(index, 1);
      if (clearAll) {
        return {
          ...state,
          files: [],
          isSaving: false,
          isCleared: true,
        };
      }
      return {
        ...state,
        files: fileData,
        isSaving: false,
        isCleared: true,
      };
    }
    case removeScopedFile.SUCCESS: {
      const { fileMetaDataId, scope, clearAll, clearSavedFiles } =
        action.payload;
      if (clearAll) {
        return {
          ...state,
          scopedFiles: { ...state.scopedFiles, [scope]: [] },
          isSaving: false,
          isCleared: true,
          scopedFilesLength: { ...state.scopedFilesLength, [scope]: null },
        };
      }
      if (clearSavedFiles) {
        return {
          ...state,
          isSaving: false,
          isCleared: true,
          scopedFilesLength: { ...state.scopedFilesLength, [scope]: null },
        };
      }
      const fileData = [...(state.scopedFiles[scope] || [])];
      const index = fileData.findIndex(
        (file) => file.fileMetaDataId === fileMetaDataId
      );
      fileData.splice(index, 1);
      return {
        ...state,
        scopedFiles: { ...state.scopedFiles, [scope]: fileData },
        isSaving: false,
        isCleared: true,
        scopedFilesLength: {
          ...state.scopedFilesLength,
          [scope]: fileData.length,
        },
      };
    }
    case downloadFile.SUCCESS: {
      const url = action.payload;
      return {
        ...state,
        downloadLink: url,
        isDownloading: false,
      };
    }
    case downloadFile.FAILURE: {
      return {
        ...state,
        isDownloading: false,
      };
    }
    case pinFile.SUCCESS: {
      return {
        ...state,
        files: [],
        isPinning: false,
      };
    }
    case pinFile.FAILURE: {
      return {
        ...state,
        files: [],
        isPinning: false,
      };
    }
    case uploadFileMetaData.FAILURE:
    case editFile.FAILURE:
    case bookmarkFiles.FAILURE:
    case uploadFileMetaData.SUCCESS: {
      return {
        ...state,
        files: [],
        isSaving: false,
      };
    }

    case deleteFiles.FAILURE:
    case deleteFiles.SUCCESS: {
      return {
        ...state,
        files: [],
        isDeleting: false,
      };
    }
    case uploadFile.FAILURE:
    case uploadScopedFile.FAILURE:
    case removeFile.FAILURE:
      return {
        ...state,
        isSaving: false,
        isUploadError: true,
      };
    default:
      return state;
  }
};

export default fileUploadReducer;
